
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categories/[category_slug]",
      function () {
        return require("private-next-pages/categories/[category_slug]/index.tsx");
      }
    ]);
  